module.exports = __webpack_public_path__ + "img/anomaly-fr.cfc4c4f9.jpg";